import type { ComponentProps } from "react";
import React, { useMemo } from "react";
import { Footer as BaseFooter, Logo } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Separator, useMedia, View } from "tamagui";

import { ContactUsDialog } from "../feature/contact-us";

type FooterProps = ComponentProps<typeof BaseFooter.Container>;

export const Footer: React.FC<FooterProps> = (props) => {
  const { t } = useTranslation("footer");
  const { sm } = useMedia();
  const links = t("links", { returnObjects: true });
  const year = useMemo(() => new Date().getFullYear(), []);

  if (sm) {
    return (
      <BaseFooter.Container {...props}>
        <BaseFooter.Content media="md">
          <Logo
            style={{
              height: 28,
              width: 166,
            }}
          />
          <BaseFooter.Links media="md">
            {links.map((link) => {
              if (link.href === undefined) {
                return (
                  <ContactUsDialog
                    key={link.text}
                    trigger={
                      <BaseFooter.Link font="md">{link.text}</BaseFooter.Link>
                    }
                  />
                );
              }

              return (
                <BaseFooter.Link font="md" key={link.text} href={link.href}>
                  {link.text}
                </BaseFooter.Link>
              );
            })}
          </BaseFooter.Links>
        </BaseFooter.Content>
        <Separator width={"100%"} maxWidth={295} alignSelf="center" />
        <BaseFooter.Content media="md" marginBottom={"$2"}>
          <BaseFooter.CopyrightText>
            {t("copyright", { year })}
          </BaseFooter.CopyrightText>
        </BaseFooter.Content>
        <BaseFooter.MailTo email={t("email")} />
      </BaseFooter.Container>
    );
  }

  return (
    <BaseFooter.Container
      // paddingHorizontal={"$3"}
      paddingTop={"$1.2"}
      paddingBottom={"$3"}
      {...props}
    >
      <BaseFooter.Content>
        <BaseFooter.Links media="lg">
          <BaseFooter.LinksTitle>{t("title")}</BaseFooter.LinksTitle>
          {links.map((link) => {
            if (link.href === undefined) {
              return (
                <ContactUsDialog
                  key={link.text}
                  trigger={<BaseFooter.Link>{link.text}</BaseFooter.Link>}
                />
              );
            }

            return (
              <BaseFooter.Link key={link.text} href={link.href}>
                {link.text}
              </BaseFooter.Link>
            );
          })}
        </BaseFooter.Links>
        <View flexDirection="column" gap={"$3"} maxWidth={260}>
          <BaseFooter.Disclaimer>{t("disclaimer")}</BaseFooter.Disclaimer>
          <BaseFooter.CopyrightText>
            {t("copyright", { year })}
          </BaseFooter.CopyrightText>
        </View>
      </BaseFooter.Content>

      <BaseFooter.Content>
        <BaseFooter.LogoContainer media="lg">
          <BaseFooter.Logo />
        </BaseFooter.LogoContainer>
      </BaseFooter.Content>
    </BaseFooter.Container>
  );
};
